module.exports = __webpack_public_path__ + "static/media/tile_menu_icon_e_gift.dd95563a.png";